/**
 * Dashboard API Service
 * 處理客戶端 Dashboard 統計相關的 API 請求
 */

import apiClient from '../axios.js';

export default {
  /**
   * 獲取 Dashboard 統計數據
   * @param {boolean} refresh - 是否強制刷新
   * @returns {Promise} API 響應
   */
  getStats(refresh = false) {
    return apiClient.get('/client/dashboard/stats', {
      params: { refresh }
    });
  },

  /**
   * 獲取趨勢數據
   * @param {string} metric - 指標類型 (revenue, members, orders)
   * @param {number} days - 天數（預設30天）
   * @returns {Promise} API 響應
   */
  getTrends(metric, days = 30) {
    return apiClient.get(`/client/dashboard/trends/${metric}`, {
      params: { days }
    });
  },

  /**
   * 獲取排行榜數據
   * @param {string} type - 排行榜類型 (members, coupons)
   * @param {number} limit - 限制筆數
   * @returns {Promise} API 響應
   */
  getRanking(type, limit = 10) {
    return apiClient.get(`/client/dashboard/ranking/${type}`, {
      params: { limit }
    });
  }
};
